import { Member } from 'data/members';
import interceptor from './interceptor';

const getAllMembers = () => {
  const request = interceptor.apiWithAuth.get('/member/get-all-members/');
  return request
    .then(response => response.data)
    .catch(error => {
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};

const getMemberByID = (userid: string) => {
  const request = interceptor.apiWithAuth.get(
    '/member/get-member-by-id/' + userid
  );
  return request
    .then(response => {
      if (response.data.dateCreated) {
        response.data.dateCreated = new Date(
          response.data.dateCreated
        ).toISOString();
      }
      if (response.data.dateModified) {
        response.data.dateModified = new Date(
          response.data.dateModified
        ).toISOString();
      }
      if (response.data.dateDeleted) {
        response.data.dateDeleted = new Date(
          response.data.dateDeleted
        ).toISOString();
      }
      return response.data;
    })
    .catch(error => {
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};

//update member
const updateMember = (member: Member) => {
  const request = interceptor.apiWithAuth.put('/member/update-member/', member);
  return request
    .then(response => response.data)
    .catch(error => {
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};
const membersService = { getAllMembers, getMemberByID, updateMember };
export default membersService;
